
export default
  {
    removeFromArrayByKey(array, key, value) {
      
      if(!array)
        return;

      for (let i = 0; i < array.length; i++) {
        if (array[i][key] == value) {
          array.splice(i, 1);
          if(!array)
            array = [];
          return array;
        }
      }

      return array;
    },

    removeFromArrayByIndex(array, index) {
      if(!array)
        return;

      array.splice(index, 1);
      if(!array)
        array = [];
      return array;
    },

    replaceInArray(array, key, object) {
      if(!array)
        return;

      for (let i = 0; i < array.length; i++) {
        if (array[i][key] == object[key]) {
          array[i] = object;
          return array;
        }
      }
    },

    insertInArray(array, index, object) {
      if(!array)
        return;

      array.splice(index, 0, object);
      return array;
    },

    urlCombine(base, path) {
      if (base.substring(base.length - 1) != "/") {
        base += "/";
      }
      return base + path;
    },

    sortByKey(array, key) {
      return array.sort(function (a, b) {
          let x = a[key]; let y = b[key];
          if(x == null && y != null) return 1;
          if(y == null && x != null) return -1;
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      });
    },

    expandJSON(json, priorKey, priorSub) {
      let result = {};
      if(!priorSub)
        priorSub = "$[";
      for(let key in json) {
          let value = json[key];
          let sub = priorSub;

          // append key to sub (before braces and dot are added)
          if(sub != "$[")
              sub += ",";
          sub += key;

          // close sub
          let closedSub = sub + "]";

          // format key w/ brace or dot
          if(Array.isArray(json)) {
            key = "[" + json.indexOf(value) + "]";
          }
          else if(typeof(json) == "object" && priorKey) {
            key = "." + key;
          }

          // append key to prior key
          let expandedKey = key;
          if(priorKey)
              expandedKey = priorKey + key;
          
          result[expandedKey] = {value: value, sub: closedSub};

          if(typeof(value) == "object") {
            let inner = this.expandJSON(value, expandedKey, sub);
            for(let innerKey in inner) {
              let innerValue = inner[innerKey].value;
              let innerSub = inner[innerKey].sub;
              result[innerKey] = {value: innerValue, sub: innerSub};
            }
          }          
       }
      return result;
    },

    getInputFields(store, workflow) {
      let allFields = {};
      let types = store.getters["nodeStore/getInputTypes"];
      for (let i = 0; i < types.length; i++) {
        let type = types[i];

        if(!type.plural)
          continue;

        for (let j = 0; j < workflow[type.plural].length; j++) {
          let input = workflow[type.plural][j];
          let fields = [];

          // vars
          if(input.vars) {
            for (let k = 0; k < input.vars.length; k++) {
              let field = input.vars[k];
              fields.push({ object: input.shortname, field: field.name });
            }
          }

          // fields
          if(input.fields) {
            for (let k = 0; k < input.fields.length; k++) {
              let field = input.fields[k];
              fields.push({ object: input.shortname, field: field });
            }
          }

          // config.fields (geoInputs)
          if(input.config && input.config.fields) {
            for (let k = 0; k < input.config.fields.length; k++) {
              let field = input.config.fields[k];
              fields.push({ object: input.shortname, field: field });
            }
          }

          // compareNodes
          if(input.inputA && input.inputA.fields) {
            for (let k = 0; k < input.inputA.fields.length; k++) {
              let field = input.inputA.fields[k];
              fields.push({
                object: input.shortname,
                field: field,
                alias: "",
                child: { shortname: input.inputA.shortname, name: input.inputA.name }
              });       
            }
          }
          if(input.inputB && input.inputB.fields) {
            for (let k = 0; k < input.inputB.fields.length; k++) {
              let field = input.inputB.fields[k];
              fields.push({
                object: input.shortname,
                field: field,
                alias: "",
                child: { shortname: input.inputB.shortname, name: input.inputB.name }
              });   
            }
          }

          // geometry field
          if(input.includeGeometry) {
            fields.push({ object: input.shortname, field:  "GEOMETRY" });
            fields.push({ object: input.shortname, field:  "GEOMETRY.SPATIALREFERENCE" });
            if(input.geometryType == "esriGeometryPoint") {
              fields.push({ object: input.shortname, field:  "GEOMETRY.X" });
              fields.push({ object: input.shortname, field:  "GEOMETRY.Y" });
            }
          }
          
          if(fields.length > 0)
            allFields[input.shortname] = fields;
        }
      }
      return allFields;
    },

    getOutputFields(store, workflow) {
      let allFields = {};

      let types = store.getters["nodeStore/getOutputTypes"];
      for (let i = 0; i < types.length; i++) {
        let type = types[i];

        for (let j = 0; j < workflow[type.plural].length; j++) {
          let output = workflow[type.plural][j];
          let fields = [];

          // vars
          if(output.vars) {
            for (let k = 0; k < output.vars.length; k++) {
              let field = output.vars[k];
              fields.push({object: output.shortname, field: field.name });
            }
          }

          // fields
          if(output.fields) {
            for (let k = 0; k < output.fields.length; k++) {
              let field = output.fields[k];
              fields.push({object: output.shortname, field: field });
            }
          }
          
          // child fields
          if(output.childObjects) {
            for (let k = 0; k < output.childObjects.length; k++) {
              let child = output.childObjects[k];
              for (let l = 0; l < child.fields.length; l++) {
                let field = child.fields[l];
                fields.push({
                  object: output.shortname,
                  field: field,
                  alias: !!child.value ? child.value : "",
                  child: { shortname: child.shortname, name: child.name }
                });       
              }
            }
          }
          
          // geometry
          if(output.includeGeometry) {
            fields.push({ 
              object: output.shortname, 
              field: "GEOMETRY" 
            });
          }

          if(fields.length > 0) {
            if(output.name)
              allFields[`${output.shortname} ${output.name}`] = fields;
            else
              allFields[output.shortname] = fields;
          }
       }
      }
      return allFields;
    },

    fieldsToOptionGroups(fields) {
      let groups = {};
      let objects = Object.keys(fields);
      for(let i = 0; i < objects.length; i++) {
        let object = objects[i];
        let objectFields = fields[object];
        let options = [];
        for(let j = 0; j < objectFields.length; j++) {
          let field = objectFields[j];
          let option = {value: field};
          if(field.child) {
            let alias = field.alias != "" ? " " + field.alias : "";
            option.text = `${field.object}, ${field.child.shortname}: `;

            if('name' in field.child)
            {
              if(field.child.name && field.child.name != "")
                option.text += `${field.child.name}.`;
              delete option.value.child.name;
            }

            option.text += `${field.field}`;

            if(alias)
              option.text += ` | ${alias}`;

            delete option.value.alias
          }
          else {
            option.text = field.object + ": " + field.field;
          }
          options.push(option);
        }
        groups[object] = options;
      }
      return groups;
    }

  }



// WEBPACK FOOTER //
// ./src/util/util.js